/**
 * Coercizione della bozza wizard senza alzare DRAFT_SCHEMA_VERSION.
 *
 * Stato civile e stile alimentare fuori enum tornano vuoti, così il menu
 * non rimanda testo libero. Figli non numerico (0–3 cifre) torna vuoto.
 * Il resto della bozza, inclusa la storia clinica, resta com'è.
 */

import {
  STATO_CIVILE_VALORI,
  STILE_ALIMENTARE_VALORI,
} from '@shared/constants/scelte-anagrafica';
import type { OnboardingFormValues } from '../components/onboarding-form-types';

const FIGLI_NUMERICO = /^\d{0,3}$/;

function valoreInElenco(elenco: readonly string[], value: unknown): string {
  return typeof value === 'string' && elenco.includes(value) ? value : '';
}

function figliNumerico(value: unknown): string {
  return typeof value === 'string' && FIGLI_NUMERICO.test(value) ? value : '';
}

export function normalizzaBozzaOnboarding(
  draft: OnboardingFormValues
): OnboardingFormValues {
  const step3 = draft.step3;
  if (!step3) return draft;
  return {
    ...draft,
    step3: {
      ...step3,
      statoCivile: valoreInElenco(STATO_CIVILE_VALORI, step3.statoCivile),
      tipoDieta: valoreInElenco(STILE_ALIMENTARE_VALORI, step3.tipoDieta),
      figli: figliNumerico(step3.figli),
    },
  };
}
